import { Step } from 'react-joyride';

/**
 * Shown when the user declines the clients walkthrough (design: "If user declines any walkthrough").
 */
export const clientsDeclineTipSteps: Step[] = [
  {
    target: '#walkthrough-clients-help-button',
    content:
      'Ok, you can always get help by tapping the question mark at the top of the screen!',
    disableOverlayClose: true,
    disableCloseOnEsc: true,
    disableBeacon: true,
    placement: 'bottom',
    offset: 12,
    spotlightPadding: 8,
    floaterProps: {
      disableFlip: true,
      disableAnimation: true,
      placement: 'bottom',
      offset: 12,
    },
  },
];
